import { useState, useRef, useEffect, useCallback } from "react";

let firstState;

const hasAnyError = obj => Object.keys(obj).some(key => {
  if (typeof obj[key] === 'object') {
    return hasAnyError(obj[key]);
  }
  return !!obj[key];
});

export const useValidator = (state, validator) => {
  const [errors, setErrors] = useState({});
  const ref = useRef();

  useEffect(() => {
    if (!ref.current) {
      firstState = state;
      ref.current = state;
      return;
    }

    if (state === firstState) {
      return setErrors({});
    }

    const _errors = validator(ref.current, state);

    setErrors(prevErrors => ({
      ...prevErrors,
      ..._errors,
    }));

    ref.current = state;
  }, [state, validator]);

  const isValid = useCallback(() => {
    const _errors = validator({}, state);
    const result = hasAnyError(_errors);

    if (result) {
      setErrors(_errors);
    }

    return !result;
  }, [state, validator]);

  return [errors, isValid];
}
